export default {
  title: 'e-Geschenkkarten kaufen',
  subtitle:
    'Sag’s mit einem Gutschein von {{companyName}}. Ideal für Geburtstage, als Dankeschön oder einfach so – flexibel einlösbar für Speisen & Getränke.',
  header: {
    title: 'Gutschein',
    subtitle: 'Freude schenken',
  },
  buttons: {
    buy_now: 'Jetzt kaufen',
  },
};
